import {Component, OnInit} from '@angular/core';
import {NgIf, NgFor} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {FormatAddressPipe} from '../../shared/pipes/formatAddress.pipe';
import {SessionStorageService} from '../../core/services/session-storage.service';
import {storageKey} from '../../api/enum/storage.constants';
import {InstituteService} from '../../api/institute.service';
import {SubscriptionService} from '../../api/subscription.service';

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [NgIf, NgFor, FormsModule, FormatAddressPipe],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss'
})
export class SummaryComponent implements OnInit {

  termsAccepted = false;
  summaryData: any = null;
  isSubmitting = false;
  submitError: string | null = null;
  submitErrors: {loc: string; msg: string}[] = [];

  discountCode = '';
  isApplyingDiscount = false;
  discountError: string | null = null;
  discountAmount: number | null = null;
  originalPrice: number | null = null;
  finalPrice: number | null = null;

  constructor(
    private storage: SessionStorageService,
    private router: Router,
    private instituteService: InstituteService,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit(): void {
    const executiveCode = this.storage.get<string>(storageKey.executiveCode);
    const instituteFormData = this.storage.get<any>(storageKey.instituteFormData);
    const subscriptionData = this.storage.get<any>(storageKey.subscriptionData);

    if (!executiveCode || !instituteFormData || !subscriptionData) {
      this.router.navigateByUrl('/');
      return;
    }

    this.summaryData = {
      executiveCode,
      admin: instituteFormData.admin,
      institute: instituteFormData.institute,
      subscription: subscriptionData,
    };

    // Extract numeric price from e.g. "₹1490/Student/Year"
    const priceMatch = subscriptionData.price?.match(/[\d.]+/);
    this.originalPrice = priceMatch ? parseFloat(priceMatch[0]) : null;
    this.finalPrice = this.originalPrice;
  }

  applyDiscount(): void {
    if (!this.discountCode.trim()) return;
    this.isApplyingDiscount = true;
    this.discountError = null;
    this.discountAmount = null;
    this.finalPrice = this.originalPrice;

    this.subscriptionService.applyDiscountCode(this.discountCode.trim()).subscribe({
      next: (res) => {
        this.isApplyingDiscount = false;
        this.discountAmount = parseFloat(res.data.discount);
        this.finalPrice = (this.originalPrice ?? 0) - this.discountAmount;
        this.summaryData.subscription.discount_code = this.discountCode.trim();
      },
      error: (err) => {
        this.isApplyingDiscount = false;
        this.discountError = err?.error?.message?.message ?? 'Invalid discount code.';
      }
    });
  }

  removeDiscount(): void {
    this.discountAmount = null;
    this.finalPrice = this.originalPrice;
    this.discountCode = '';
    this.discountError = null;
    delete this.summaryData.subscription.discount_code;
  }

  confirmSubscription(): void {
    if (!this.termsAccepted || this.isSubmitting) return;
    this.isSubmitting = true;
    this.submitError = null;
    this.submitErrors = [];

    this.instituteService.register(this.summaryData).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.storage.clear();
        this.router.navigateByUrl('/thank-you');
      },
      error: (err) => {
        this.isSubmitting = false;
        this.submitError = err?.error?.message?.message ?? 'Registration failed. Please try again.';
        this.submitErrors = err?.error?.errors ?? [];
      }
    });
  }

  backToPricing(): void {
    this.router.navigateByUrl('/subscription');
  }
}
